module.exports = __webpack_public_path__ + "fonts/Lato-700-7.9c8812e.woff2";